import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

import ArrowLeft from './arrow-left';
import ArrowRight from './arrow-right';
import Close from './close';
import Dots from './dots';

const useStyles = createUseStyles({
  footer: {
    composes: ['flex-columns', 'flex-center', 'items-center', 'p12'],
  },
});

const RideTooltipFooterComponent = function RideTooltipFooterComponent({
  backProps,
  closeProps,
  index,
  isLastStep,
  primaryProps,
  size,
}) {
  const classes = useStyles();
  return (
    <div className={classes.footer}>
      <ArrowLeft backProps={backProps} index={index} />
      <Dots index={index} size={size} />
      {!isLastStep && <ArrowRight primaryProps={primaryProps} />}
      {isLastStep && <Close closeProps={closeProps} />}
    </div>
  );
};

RideTooltipFooterComponent.propTypes = {
  backProps: PropTypes.shape().isRequired,
  closeProps: PropTypes.shape().isRequired,
  index: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  primaryProps: PropTypes.shape().isRequired,
  size: PropTypes.number.isRequired,
};

RideTooltipFooterComponent.displayName = 'RideTooltipFooterComponent';

export default RideTooltipFooterComponent;
